import type { SessionAssignationRow } from "@services/types/session-assignation/sessionAssignationTypes";
import { netUnassignedInstructorIds } from "@utils/unassignedInstructors";

type RowsState = Readonly<{
  originalRows: readonly SessionAssignationRow[];
  rows: readonly SessionAssignationRow[];
}>;

const instructorIds = (row: SessionAssignationRow | undefined) =>
  (row?.instructors ?? []).map(instructor => instructor?.id);

/**
 * The instructors unassigned in the sessions view, for `unassignedInstructorIds` (CHS-2944).
 *
 * Every occurrence kept in the draft is compared with its saved row, whatever sessions the
 * reconciliation later groups it into. Deleted occurrences are not unassignments and new ones
 * have no saved instructors.
 */
export const rowsUnassignedInstructorIds = ({ originalRows, rows }: RowsState): string[] => {
  const originalsById = new Map(originalRows.map(row => [row.localId, row]));

  return netUnassignedInstructorIds(
    rows
      .filter(row => row.pendingState !== "deleted")
      .map(row => ({
        originalIds: instructorIds(row.origin ? originalsById.get(row.localId) : undefined),
        finalIds: instructorIds(row),
      })),
  );
};
